// @ts-strict
import { Injectable } from '@angular/core';

declare let aptrinsic: any;
/**
 * Initialise the locale service BEFORE the root application component is
 * loaded.  Simply add the module to the root module, and the initialiser
 * will be automatically added.
 */
@Injectable({
  providedIn: 'root'
})
export class LMGainsightInitializerService {
  /**
   * Initializes gainsight for this web application.
   */
  async initialize() {
    //passing user and account objects:
    if (LandmarkContext.gainsightEnabled) {
      aptrinsic("identify",
        {
          //User Fields
          "id": LandmarkContext.userID, // Required for logged in app users
          // "configuredFeatures": LandmarkContext.configuredFeatures.toString(),
          "modules": LandmarkContext.webApps,
        },
        {
          //Account Fields
          "id": LandmarkContext.tenantId, //Required
        });
      aptrinsic('set', 'globalContext', {"LandmarkWebVersion": LandmarkContext.buildVersion});
    }
  }
}
